<template>
  <b-card
    v-if="courseData"
    no-body
    class="card-statistics"
  >
    <b-card-header>
      <b-card-title>Statistics</b-card-title>
      <b-card-text class="font-small-2 mr-25 mb-0">
        General View
      </b-card-text>
    </b-card-header>
    <b-card-body class="statistics-body">
      <b-row>
        <b-col  xl="3"
          sm="6"
          :class="courseData.customClass"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="48"
                :variant="courseData.color"
              >
                <feather-icon
                  size="24"
                  :icon="courseData.icon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ courseData.title }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                {{ courseData.subtitle }}
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
          <b-col  xl="3"
          sm="6"
          :class="participiantData.customClass"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="48"
                :variant="participiantData.color"
              >
                <feather-icon
                  size="24"
                  :icon="participiantData.icon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ participiantData.title }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                {{ participiantData.subtitle }}
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
          <b-col  xl="3"
          sm="6"
          :class="examData.customClass"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="48"
                :variant="examData.color"
              >
                <feather-icon
                  size="24"
                  :icon="examData.icon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ examData.title }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                {{ examData.subtitle }}
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
          <b-col  xl="3"
          sm="6"
          :class="certificateData.customClass"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="48"
                :variant="certificateData.color"
              >
                <feather-icon
                  size="24"
                  :icon="certificateData.icon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ certificateData.title }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                {{ certificateData.subtitle }}
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>

import userStoreModule from './analitiycStoreModule'
import store from '@/store'
import router from '@/router'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'app-pages'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })
   
  
    
   const courseData = ref(null);
     
   const participiantData = ref(null);
     
   const examData = ref(null);
     
   const certificateData = ref(null);

    var statisticsItems=ref(null);
    statisticsItems.value=[
     courseData,
participiantData,
examData,
certificateData
  ];


  store.dispatch('app-pages/getSuggestionCountByStatus', { id: router.currentRoute.params.id,s:0 })
      .then(response => {
        courseData.value = {
      icon: 'MailIcon',
      color: 'light-info',
      title: response.data.totalposts,
      subtitle: 'New Suggestions',
      customClass: 'mb-2 mb-xl-0',
    } ;
        //console.log( courseData.value);

        })
      .catch(error => {
        if (error.response.status === 404) {
          courseData.value = undefined
        }
      });
       store.dispatch('app-pages/getSuggestionCountByStatus', { id: router.currentRoute.params.id, s:1})
      .then(response => {
   
        participiantData.value ={
      icon: 'LoaderIcon',
      color: 'light-warning',
      title: response.data.totalposts,
      subtitle: 'In Progress',
      customClass: 'mb-2 mb-xl-0',
    }
        })
      .catch(error => {
        if (error.response.status === 404) {
          participiantData.value = undefined
        }
      });
       store.dispatch('app-pages/getSuggestionCountByStatus', { id: router.currentRoute.params.id, s:200 })
      .then(response => {
   
        examData.value =  {
      icon: 'XIcon',
      color: 'light-danger',
      title: response.data.totalposts,
      subtitle: 'Rejected',
      customClass: 'mb-2 mb-sm-0',
    }, response.data.data;
        
        })
      .catch(error => {
        if (error.response.status === 404) {
          examData.value = undefined
        }
      });
       store.dispatch('app-pages/getSuggestionCountByStatus', { id: router.currentRoute.params.id , s:100})
      .then(response => {
  
        certificateData.value =  {
      icon: 'SmileIcon',
      color: 'light-success',
      title: response.data.totalposts,
      subtitle: 'Confirmed',
      customClass: '',
    } ;
    
        
        })
      .catch(error => {
        if (error.response.status === 404) {
          certificateData.value = undefined
        }
      });

    

    return {

      courseData,
      participiantData,
      examData,
      certificateData,
      statisticsItems

    }
  },

}
</script>
